import React, { Component } from "react";
import { reduxForm, Field } from "redux-form";
import { connect } from "react-redux";
import { FormGroup, Col, Label, Input, Row, Button, Spinner } from "reactstrap";
//import DropdownList from 'react-widgets/lib/DropdownList'
//import 'react-widgets/dist/css/react-widgets.css'

import TextField from '@material-ui/core/TextField'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'


const renderField = ({
    input,
    type,
    placeholder,
    label,
    disabled,
    readOnly,
    meta: { touched, error, warning },
}) => (
        <Row>
            <Col md="12">
                <Label htmlFor="{input}" className="col-form-label">
                    {label}
                </Label>
            </Col>
            <Col md="12">
                <Input
                    {...input}
                    type={type}
                    placeholder={placeholder}
                    disabled={disabled}
                    readOnly={readOnly}
                ></Input>
                {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
            </Col>
        </Row>
    );

const validate = values => {
    const errors = {}
    const requiredFields = [
        'tipo'
    ]

    const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;

    const requiredFields2 = [
        'numerohijos'
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar un tipo de tutor';
        }
    })

    requiredFields2.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Debes seleccionar número de hijos de tutor';
        }
    })

    if (!values.apellidopaterno || values.apellidopaterno === "") {
        errors.apellidopaterno = "Debes ingresar apellido paterno de tutor";
    }

    if (!values.apellidomaterno || values.apellidomaterno === "") {
        errors.apellidomaterno = "Debes ingresar apellido materno de tutor";
    }

    if (!values.nombres || values.nombres === "") {
        errors.nombres = "Debes ingresar nombres de tutor";
    }

    if (!values.ocupacion || values.ocupacion=== "") {
        errors.ocupacion = "Debes ingresar ocupación de tutor";
    }

    if (!values.trabajaen || values.trabajaen === "") {
        errors.trabajaen = "Debes ingresar lugar de trabajo de tutor";
    }

    if (!values.telefono || values.telefono === "") {
        errors.telefono = "Debes ingresar teléfono de tutor";
    }

    if (!pattern.test(values.correo)) {
        errors.correo = 'Correo con formato invalido';
    }

    /*
    if (!values.clave || values.clave === "") {
        errors.clave = "Debes clave del tutor";
    }
    */

    return errors
}

const renderFromHelper = ({ touched, error }) => {
    if (!(touched && error)) {
        return
    } else {
        return <FormHelperText>{touched && error}</FormHelperText>
    }
}

const renderSelectField = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'tipo',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )

const renderSelectField2 = ({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
}) => (
        <FormControl error={touched && error}>
            <InputLabel htmlFor="age-native-simple">Número Hijos</InputLabel>
            <Select
                native
                {...input}
                {...custom}
                inputProps={{
                    name: 'numerohijos',
                    id: 'age-native-simple'
                }}
            >
                {children}
            </Select>
            {renderFromHelper({ touched, error })}
        </FormControl>
    )



const mapStateToProps = (state) => {

    let tipo            ="";
    let apellidopaterno = "";
    let apellidomaterno = "";
    let nombres         = "";
    let ocupacion       = "";
    let trabajaen       = "";
    let telefono        = "";
    let correo          = "";
    let numerohijos     = ""; //1,2,3,4..etc
    //let clave      = "";

    return {
        initialValues: {
            tipo,    
            apellidopaterno,
            apellidomaterno,
            nombres,
            ocupacion,
            trabajaen,
            telefono,
            correo,
            numerohijos,
            //clave
        }
    };

}; //END MAPSTATETOPROPS

class FormTutorC extends Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>

                <FormGroup row>

                    <Col md={6}>
                        <FormGroup>

                            <Field
                                name="tipo"
                                component={renderSelectField}
                            >
                                <option value="" />
                                <option value={'Madre'}>Madre</option>
                                <option value={'Padre'}>Padre</option>
                                <option value={'Tutor'}>Tutor</option>
                            </Field>

                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="apellidopaterno"
                                component={renderField}
                                label="Apellido Paterno :"
                            />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="apellidomaterno"
                                component={renderField}
                                label="Apellido Materno :"
                            />
                        </FormGroup>
                    </Col>

                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="nombres"
                                component={renderField}
                                label="Nombres :"
                            />
                        </FormGroup>
                    </Col>

                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="ocupacion"
                                component={renderField}
                                label="Ocupación :"
                            />
                        </FormGroup>
                    </Col>

                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="trabajaen"
                                component={renderField}
                                label="Trabaja En :"
                            />
                        </FormGroup>
                    </Col>

                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="telefono"
                                component={renderField}
                                label="Teléfono :"
                            />
                        </FormGroup>
                    </Col>

                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                type="text"
                                name="correo"
                                component={renderField}
                                label="Correo :"
                            />
                        </FormGroup>
                    </Col>

                    
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                name="numerohijos"
                                component={renderSelectField2}
                            >
                                <option value="" />
                                <option value={'1'}>1</option>
                                <option value={'2'}>2</option>
                                <option value={'3'}>3</option>
                                <option value={'4'}>4</option>
                                <option value={'5'}>5</option>
                                <option value={'6'}>6</option>
                                <option value={'7'}>7</option>
                                <option value={'8'}>8</option>
                                <option value={'9'}>9</option>
                                <option value={'10'}>10</option>
                            </Field>

                        </FormGroup>
                    </Col>


                    {
                        /* 
                        <Col md={6}>
                            <FormGroup>
                                <Field
                                    type="number"
                                    name="clave"
                                    component={renderField}
                                    label="Clave :"
                                />
                            </FormGroup>
                        </Col>                        
                        */
                    }


                </FormGroup>

                <FormGroup row>
                    <Col md="12">
                        <FormGroup>
                            

                            {
                                !this.props.submitSucceeded? (
                                    <Button
                                        color="dark"
                                        type="submit"
                                        disabled={this.props.submitSucceeded}

                                    >
                                        Enviar
                                    </Button>
                                ): (
                                        <Button variant="success" disabled>
                                            <Spinner
                                                as="span"
                                                animation="grow"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                                variant="success"
                                                role="status"
                                            />
                                            Procesando solicitud...
                                        </Button>

                                    )
                            
                            }

                        </FormGroup>
                    </Col>
                </FormGroup>

            </form>
        );
    }
}

FormTutorC = reduxForm({
    form: "formTutorC",
    validate,
    enableReinitialize: true,
})(FormTutorC);
export default connect(mapStateToProps, null)(FormTutorC);
